import { render, staticRenderFns } from "./contentCourseRoleManage.vue?vue&type=template&id=2cec07bf&"
import script from "./contentCourseRoleManage.vue?vue&type=script&lang=js&"
export * from "./contentCourseRoleManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports